import { OutboundTable } from './components/OutboundTable'
import { Button, Checkbox, HStack, Icon, VStack } from '@musinsa/mwms-ds'
import useModal from '@/hooks/useModal'
import { OverseasPriorityModal } from './components/cut-off/OverSeasPriorityModal'
import { useParsedQuery } from '@/hooks/useParsedQuery'
import { useCutOffDateOnly } from './hooks/useCutOffDate'
import dayjs from 'dayjs'
import { DATE_FORMAT } from '@/utils/consts'
import { Suspense } from 'react'
import { OutboundSchedulePageQueryParams, OutboundScheduleShipperCode } from './types/query'
import SelectBox from '@/components/content/SelectBox'
import Text from '@/components/content/Text'
import { useScheduleShipper } from './hooks/useScheduleShipper'
import { ScheduleShipperProvider } from './context/ScheduleShipperContext'
import { SCHEDULE_SHIPPER_EMPTY_MESSAGE } from '@/pages/outbound/scheduleShipper'
import { colorSystem } from '@/styles/theme'

export default function OutboundGI11() {
  const { parsedQs, replaceQuery } = useParsedQuery<OutboundSchedulePageQueryParams>()
  const showPastCutOff = parsedQs.showPastCutOff === 'true'

  const { cutOffDate } = useCutOffDateOnly()

  // usedBundle 필터 → 허용 화주 교집합으로 좁힌 선택지·선택값 — 확정 전에는 그리드를 열지 않는다 (LOGISPRD-12495)
  const scheduleShipper = useScheduleShipper()

  const overseasModal = useModal()

  const handleDateChange = (type: 'prev' | 'next') => {
    const newDate = {
      prev: dayjs(cutOffDate).subtract(1, 'day').format(DATE_FORMAT.date),
      next: dayjs(cutOffDate).add(1, 'day').format(DATE_FORMAT.date),
    }[type]

    replaceQuery({ ...parsedQs, date: newDate })
  }

  const handleHidePastCutOffChange = () => {
    replaceQuery({ ...parsedQs, showPastCutOff: showPastCutOff ? undefined : 'true' })
  }

  return (
    <>
      <VStack style={{ height: '100%', minHeight: 0, minWidth: 1280 }}>
        <HStack justify="space-between" align="center">
          <HStack gap={16} align="center">
            <Button size="sm" kind="secondary" style={{ padding: 6, height: 'auto' }} onClick={() => handleDateChange('prev')}>
              <Icon name="arrow-left-line" />
            </Button>
            <span style={{ fontSize: 24, fontWeight: 500 }}>{cutOffDate}</span>
            <Button size="sm" kind="secondary" style={{ padding: 6, height: 'auto' }} onClick={() => handleDateChange('next')}>
              <Icon name="arrow-right-line" />
            </Button>

            {scheduleShipper.options.length > 0 && (
              <div style={{ width: 160 }}>
                <SelectBox<OutboundScheduleShipperCode>
                  size="large"
                  options={scheduleShipper.options}
                  block
                  value={scheduleShipper.shipperCode}
                  placeholder={false}
                  onChange={(shipperCode) => replaceQuery({ ...parsedQs, shipperCode })}
                />
              </div>
            )}
          </HStack>

          <HStack gap={16} align="center">
            <Checkbox labelText="지난 시간대 보기" size="sm" checked={showPastCutOff} onChange={handleHidePastCutOffChange} />
            <Button kind="secondary" content="해외출고 관리" onClick={overseasModal.onOpenModal} />
          </HStack>
        </HStack>

        {scheduleShipper.shipperCode ? (
          <ScheduleShipperProvider shipperCode={scheduleShipper.shipperCode}>
            <OutboundTable />
          </ScheduleShipperProvider>
        ) : (
          !scheduleShipper.isLoading && (
            <Text kind="Body_14_regular" color={colorSystem.text.common.tertiary} style={{ marginTop: 24 }}>
              {SCHEDULE_SHIPPER_EMPTY_MESSAGE}
            </Text>
          )
        )}
      </VStack>

      {overseasModal.open && (
        <Suspense fallback={null}>
          <OverseasPriorityModal onClose={overseasModal.onCloseModal} />
        </Suspense>
      )}
    </>
  )
}
